import React, { useState } from 'react'
import './MobileNavbar'
import Closeicon from '../icons/CloseIcon'
import { usePathname } from 'next/navigation'
import { useMessages } from 'next-intl'
import { useTranslations } from 'next-intl'
import { Link } from 'navigation'
import ArrowDownIcon from '../icons/ArrowDownIcon'
import { AnimatePresence, motion } from 'framer-motion'
const ToggleMenu = ({ isOpenMenu, handleCloseMenu , toggleLinkDropdown, setToggleLinkDropdown , handleToggleDropdown }) => {
  const t = useTranslations('Navbar')
  const pathname = usePathname()
  const messages = useMessages()
  const navKeys = ['services', 'fleet', 'cities', 'solution', 'clients' , 'login']


  const variants = {
    initial: {
      x: 1000,
    },
    animate: {
      x: 0,
      transition: {
        duration: 0.5,
        ease: 'easeInOut',
      },
    },
    exit: {
      x: 1000,
      transition: {
        duration: 0.5,
        ease: 'easeInOut',
      },
    },
  }
  return (
    <AnimatePresence mode='wait'>
      {isOpenMenu && (
        <motion.div
          variants={variants}
          initial='initial'
          animate='animate'
          exit='exit'
          className='toggle-menu-container'
        >
          <div className='content'>
            <div onClick={handleCloseMenu}>
              <Closeicon />
            </div>

            <ul className='flex flex-col gap-6 items-end text-[32px] mt-6'>
              {navKeys.map((key) => {
                const route = {
                  name: t(`${key}.name`),
                  path: t(`${key}.path`),
                  type: t(`${key}.type`),
                }
                const isActive = pathname === route.path

                if (route.type === 'dropdown') {
                  const subLinks = messages.Navbar[key].subLinks
                  const subLinksKeys = Object.keys(subLinks)
                  route.subLinks = subLinksKeys.map((subKey) => ({
                    name: subLinks[subKey].name,
                    path: subLinks[subKey].path,
                  }))
                }

                return (
                  <li key={key} className='link-container'>
                    {route.type === 'dropdown' ? (
                      <>
                        <div
                          onClick={() => handleToggleDropdown(route.name)}
                          className='flex items-center gap-[10px]'
                        >
                          <span>{route.name}</span>
                          <ArrowDownIcon />
                        </div>

                        <AnimatePresence mode='wait'>
                          {toggleLinkDropdown[route.name] && (
                            <motion.div
                              initial={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: 'auto' }}
                              exit={{
                                opacity: 0,
                                height: 0,
                                marginTop: 0,
                                transition: {
                                  height: { delay: 0.01, ease: 'easeInOut' },
                                },
                              }}
                              transition={{ duration: 0.3 }}
                              className='flex flex-col items-end gap-6 mt-6'
                            >
                              {route.subLinks &&
                                route.subLinks.map((link, index) => (
                                  <Link
                                    className='text-[24px]'
                                    key={index}
                                    href={link.path}
                                    onClick={handleCloseMenu}
                                  >
                                    {link.name}
                                  </Link>
                                ))}
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </>
                    ) : key === 'login' ? (
                        <a
                          href={route.path}
                          target='_blank'
                          onClick={handleCloseMenu}
                          className={`${isActive ? 'border-b' : ''}`}
                        >
                          {route.name}
                        </a>
                    ): (
                      <Link
                      href={route.path}
                      onClick={handleCloseMenu}
                      className={`capitalize ${isActive ? 'border-b' : ''}`}
                    >
                      {route.name}
                    </Link>
                    )}
                  </li>
                )
              })}
            </ul>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default ToggleMenu
